module.exports = __webpack_public_path__ + "img/disqualified.7f0011d2.svg";